<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6OHHCg/tc-custom/9780253006998.jpg?1737757332705" alt="This image is the cover for the book African Art, Interviews, Narratives, African Expressive Cultures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">African Art, Interviews, Narratives, African Expressive Cultures
      </h1>
      <p class="bookDescription body article font2">
        <p>Joanna Grabski and Carol Magee bring together a compelling collection that shows how interviews can be used to generate new meaning and how connecting with artists and their work can transform artistic production into innovative critical insights and knowledge.  The contributors to this volume include artists, museum curators, art historians, and anthropologists, who address artistic production in a variety of locations and media to question previous uses of interview and provoke alternative understandings of art.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanna Grabski, Carol Magee
      </h2>
      
      <p class="authorDescription body article"><P>Joanna Grabski is Associate Professor and Chair of Art History at Denison University. </P><P>Carol Magee is Associate Professor of Art History at the University of North Carolina at Chapel Hill. She is author of Africa in the American Imagination: Popular Culture, Racialized Identities, and African Visual Culture.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02196d88